.button {
  &[data-variant='primary-new'] {
    border: none;
    background-color: var(--mantine-color-brand-6);
    color: white;

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-brand-5);
    }

    &:disabled {
      background-color: var(--mantine-color-gray-3);
      color: var(--mantine-color-gray-6);
    }

    &:active:not([data-disabled]) {
      background-color: var(--mantine-color-brand-7);
    }
  }

  &[data-variant='secondary'] {
    border: none;

    background-color: var(--mantine-color-orange-1);
    color: var(--mantine-color-orange-6);

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-orange-2);
    }

    &:active:not([data-disabled]) {
      background-color: var(--mantine-color-orange-3);
    }

    &:disabled {
      background-color: var(--mantine-color-orange-1);
      color: var(--mantine-color-gray-3);
    }
  }

  &[data-variant='secondary-black'] {
    background-color: var(--mantine-color-gray-1);
    color: var(--mantine-color-gray-7);

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-gray-3);
    }

    &:active:not([data-disabled]) {
      background-color: var(--mantine-color-gray-0);
    }

    &:disabled {
      background-color: var(--mantine-color-gray-1);
      color: var(--mantine-color-gray-3);
    }
  }

  &[data-variant='primary-black'] {
    background-color: var(--mantine-color-gray-9);
    color: var(--mantine-color-gray-2);

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-gray-8);
    }

    &:active:not([data-disabled]) {
      background-color: var(--mantine-color-gray-10);
    }

    &:disabled {
      background-color: var(--mantine-color-gray-9);
      color: var(--mantine-color-gray-8);
    }
  }

  &[data-size='md'] {
    border-radius: 12px;
    padding: 10px 56px;
  }

  &[data-size='sm'] {
    border-radius: 8px;
    padding: 4px 12px;
  }
}
